// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var PropTypes = require('react').PropTypes;
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const { curry } = require('lodash/fp');

  var reportExportIframePopupActions = compose(
    withHandlers({
      onClosing: curry(onClosing),
      onCopyPasswordLink: curry(onCopyPasswordLink),
      onIFrameLoad: curry(onIFrameLoad)
    })
  );

  /**
   * Handle close action.
   * @param  {Object} props
   * @param  {Object} _
   */
  function onClosing(props, _) {
    props.loader.endLoading();
    return props.onAccept();
  }

  /**
   * Copy Password Link
   */
  function onCopyPasswordLink(props, e) {
    var inputText = document.querySelector('#izenda-ExportIframeLinkCustom');
    if (inputText) {
      inputText.disabled = false;
      inputText.select();
      document.execCommand('copy');
      inputText.disabled = true;
    }
  }

  /**
   * Handle onLoad of iframe.
   * @param  {Object} props
   * @param  {Object} _
   */
  function onIFrameLoad(props, _) {
    props.loader.endLoading();
  }

  module.exports = reportExportIframePopupActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportExportIframePopupActions.js